import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmJoinsSchema } from '../schema/AlgorithmJoinsSchema';
import { AlgorithmJoinsFormDataType } from '../schema/types';

interface AlgorithmJoinsQueryParams {
  id: number;
}

const getAlgorithmJoins = (params?: AlgorithmJoinsQueryParams) =>
  apiClient
    .get<AlgorithmJoinsFormDataType>(expand(AlgorithmUrl.JOINS, params))
    .then((response) => AlgorithmJoinsSchema.parseFormData(response.data));

export const useGetAlgorithmJoinsQuery = createApiQueryHook(
  ['algorithm-joins'],
  getAlgorithmJoins
);
